export const COGNITO_DOMAIN = 'https://emerald.auth.us-east-1.amazoncognito.com';
export const APP_DOMAIN = `https://testagent.huladesk.com`;
// export const APP_DOMAIN = `http://localhost:3000`;
export const COGNITO_AGENT_APP_CLIENT_ID = `23uoi79up86udvmr7tni5vmk2r`;
export const CCP_LOGOUT_URL = "https://emerald-px.my.connect.aws/logout"
export const API_BASE_URL = 'https://p2ai7oyuxh.execute-api.us-east-1.amazonaws.com/dev';
export const CYBERSOURCE_TEST_MODE: boolean = false 